import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum } from "components/table/lib/sort"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const RecoveriesNamed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  let initData = props.rowData[props.field]?.['namedRecoveryGroupItems'];
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object[]|null>(initData && !_.isEmpty(initData) ? initData : []);
  const [showSelected, setShowSelected] = useState<boolean>(props.rowData[props.field]?.['namedRecoveryGroupItems']?.length > 0);

  useEffect(() => {
    if (!props['rowData'][props.field] || !props['rowData'][props.field]?.['namedRecoveryGroupItems']) {
      setShowSelected(false)
    }
  }, [props['rowData']])

  const updateData = (val:any) => {
    let nextData;
    // Unselect all
    if (!val || val.length === 0){
      setData([]);
      let recoverydetail = _.cloneDeep(props.rowData[props.field])
      if (!recoverydetail) recoverydetail = {}
      if (recoverydetail['namedRecoveryGroupItems']) delete recoverydetail['namedRecoveryGroupItems']
      props.persist(recoverydetail, props.field, props.rowData);
      return
    }
    // Select/deselect one or all
    nextData = val.map(each => {
      return {'recoveryGroupNamedItemId': each}
    })
    setData(nextData);
    let recoverydetail = _.cloneDeep(props.rowData[props.field])
    if (!recoverydetail) recoverydetail = {}
    recoverydetail['namedRecoveryGroupItems'] = nextData
    props.persist(recoverydetail, props.field, props.rowData)
  }

  const attrs         = (field) => field_attrs('namedRecoveryGroupItems')(field)(props.rowData, props)
  let recoveryGroups = _.get(props, "namedItems.recoveryGroups")
  let filtered        = recoveryGroups

  if (showSelected && data){
    filtered = recoveryGroups.filter(recoveryGroup => _.find(data, {'recoveryGroupNamedItemId': recoveryGroup.recoverygroupid}));
  }

  function selectAll():void {
    data?.length === recoveryGroups.length ? updateData(null) : updateData(recoveryGroups.map(recoveryGroup => recoveryGroup.recoverygroupid))
  }

  if (sortDirty){
    sortAsc ? filtered.sort((a, b) => alphanum(a.code, b.code)) : filtered.sort((a, b) => alphanum(b.code, a.code))
  }

  const options = filtered?.map(recoveryGroup => { return { label: recoveryGroup['code'], value: recoveryGroup.recoverygroupid }})

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Recovery Groups</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: data && data.length > 0 ? data.length === recoveryGroups.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": data?.map(each => { if (each['recoveryGroupNamedItemId']) return each['recoveryGroupNamedItemId'] })}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={options}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default RecoveriesNamed
